import { CartItem } from '@/models/cart/cart-item'
import { OrderResult } from '@spa/store/modules/orderConfirm/types'

/**
 * https://github.com/my-color/front/issues/6135 でのタグ一元管理の仕組みを取り込むまで暫定的に設けられた、
 * dataLayer.pushのためのレイヤ。
 */

export function executeCyberAceConversionTag(results: OrderResult[]): void {
  window.dataLayer = window.dataLayer || []

  results.forEach((orderResult) => {
    const { commerceSalesOrder } = orderResult

    if (!commerceSalesOrder) return

    /** CyberACE用 */
    window.dataLayer.push({
      event: 'transaction',
      ecommerce: {
        purchase: {
          actionField: {
            id: commerceSalesOrder.id,
            revenue: commerceSalesOrder.subtotalPrice,
          },
          products: orderResult.order.cartItems.map(cart => convertCartItemToDataLayerFormat(cart)),
        },
      },
    })
  })
}

function convertCartItemToDataLayerFormat(cartItem: CartItem): DataLayerFormat {
  return {
    id: cartItem.skuId,
    // ショートIDとロングIDの併用については @link https://github.com/my-color/front/pull/6453#issuecomment-1127426043
    short_id: cartItem.skuShortId,
    name: cartItem.name,
    price: cartItem.unitPrice,
    brand: cartItem.brandEnglishName || '',
    category: cartItem.categories.map(c => c.pathname).join(','),
    quantity: cartItem.unitCount,
  }
}

interface DataLayerFormat {
  id: string
  short_id: string
  name: string
  price: number
  brand: string
  category: string
  quantity: number
}
